import React from "react"
import { Icon, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import GenericTopBarHeader from "../../components/GenericTopBarHeader"
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket"
import { COLORS } from "../../utils"

const HeaderBlock = styled("div")(({ fixedHeader }) => ({
  flex: "0 0 64px",
  position: fixedHeader ? "fixed" : "static",
  top: fixedHeader ? 0 : "auto",
  left: fixedHeader ? 0 : "auto",
  width: fixedHeader ? "100%" : "auto",
  zIndex: fixedHeader ? 1100 : "auto",
}))

const Header = styled("div")({
  width: "100%",
})

const HeaderTitle = styled("div")({
  display: "flex",
  gap: "8px",
  justifyContent: "center",
  alignItems: "center",
  color: COLORS.PACKAGING_EXECUTION_YELLOW,
})

const HeaderSubtitle = styled(Typography)({
  paddingLeft: 8,
  fontSize: 16,
  color: COLORS.DRAFT_GREY,
})

const PackagingExecutionHeader = ({ leftAction = null, rightAction = null, subtitle = null, fixedHeader = false }) => {
  return (
    <HeaderBlock fixedHeader={fixedHeader}>
      <GenericTopBarHeader
        leftAction={leftAction}
        title={(
          <HeaderTitle>
            <Icon>
              <ShoppingBasketIcon />
            </Icon>
            <Typography variant="h7" sx={{ fontWeight: 500 }}>
              Barquettage
            </Typography>
          </HeaderTitle>
        )}
        info={subtitle && <HeaderSubtitle>{`/ ${subtitle}`}</HeaderSubtitle>}
        className={Header}
        rightAction={rightAction}
      />
    </HeaderBlock>
  )
}

export default PackagingExecutionHeader
